import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useForm } from 'antd/lib/form/Form';
import {
  Form,
  Row,
  notification,
  DatePicker,
  Spin,
  Tag,
  Tabs,
  Card,
} from 'antd';

import DF from 'DisplayFramework';
import { shouldUpdateCompare } from 'utils/utils2';
import {
  createBroker,
  getBrokerByAssocID,
  getMyBrokerProfile,
  MgBroker,
  MgBrokerResponse,
  updateBroker,
} from 'services/parametersService';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButtonTabsTop';
import MgCompanyList from 'components/MgCompanyList';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
// import EnableDisableBrokerButton from './EnableDisableBrokerButton';
import BrokerVendorsTab from './BrokerVendorsTab';
import { BrokerForProposalType } from 'components/BrokerInput';
import { isNil } from 'lodash';
import { ArrowLeftOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import EnableDisableBrokerButton from './EnableDisableBrokerButton';
import PricingAttirbuteTable from 'pages/Configuration/Offers/components/offerPricingAttribute';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ModalControllerNV from 'components/ModalControllerNV';
import MgUserJobAuthorizationList from 'pages/Configuration/MgUserJobAuthorization/MgUserJobAuthorizationList';
import ParametersFilteringBroker from './ParametersFilteringBroker';
import BrokerOfferTransfer from './BrokerOfferTransfer';
import BokerProductTransfer from './BokerProductTransfer';
import BrokerThirdParty from './BrokerThirdParty';
import ServiceListTable from 'pages/Configuration/Service/ServiceListTable';

const { TabPane } = Tabs;

type MgBrokerWithSearch = MgBroker & {
  broker: { tpname: string; tpid: number };
};

type BrokerDetailProps = {
  associdbroker?: number;
  isCreate?: boolean;
  brokerMgid?: number;
  close?: () => void;
  refetchBrokerList?: () => void;
  setBrokerForProposal?: (BrokerForProposal: BrokerForProposalType) => void;
  hideBrokerModal?: () => void;
  hideBrokerSearchModal?: () => void;
  showAsModal?: boolean;
  modal?: boolean;
  tpidbroker?: any;
  setData?: (item: MgBrokerResponse) => void;
};

const BrokerDetail = (props: BrokerDetailProps) => {
  const {
    isCreate,
    brokerMgid,
    refetchBrokerList,
    modal,
    associdbroker,
    showAsModal,
    setData,
  } = props;
  const [form] = useForm();
  const history = useHistory();
  const { mgid: paramsMgid, associdOrCreate } = useParams<{
    mgid: string;
    associdOrCreate: string;
  }>();
  const mgid = brokerMgid
    ? brokerMgid
    : paramsMgid
    ? paramsMgid
    : localStorage.getItem('mgid') ?? 0;
  const isMyprofile =
    associdbroker || isCreate
      ? false
      : associdOrCreate === undefined
      ? true
      : associdOrCreate === 'create' || brokerMgid !== null
      ? false
      : true;
  const isCreatelocal = isCreate || associdOrCreate === 'create';
  const associd = !isCreatelocal
    ? associdOrCreate
      ? Number(associdOrCreate)
      : associdbroker
    : associdbroker;
  const [associdState, setAssocidState] = useState(associd);


  const {
    data: brokerDetail,
    refetch,
    isFetching,
  } = useBrokerDetail(Number(mgid), Number(associd), isMyprofile);

  const submit = (values: MgBrokerWithSearch) => {
    const brokerRequest: MgBroker = {
      associd: values.associd,
      brokerstatus: 'INIT',
      enddate: values.enddate
        ? moment(values.enddate).format('YYYY-MM-DD')
        : '',
      mgid: Number(mgid),
      networkcode: values.networkcode,
      tprole: values.tprole,
      startdate:
        values.startdate && moment(values.startdate).format('YYYY-MM-DD'),
      tpidbroker: Number(values.broker.tpid),
      tpname: form.getFieldValue('broker').tpname,
      tpreference: form.getFieldValue('broker').tpreference,
    };

    // if (
    //   values.enddate &&
    //   values.enddate.length !== 0 &&
    //   values.startdate > values.enddate
    // ) {
    //   // notification.error({
    //   //   message: 'the start date must be less than the end date',
    //   // });
    // } else {
      if (isNil(associdState)) {
        createBroker({ mgid: Number(mgid), brokerRequest }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            if (!modal) {
              history.push(
                `/configuration/management-company/${mgid}/broker/${response.data.associd}`
              );
            } else {
              setAssocidState(response.data.associd);
              refetch();
              refetchBrokerList && refetchBrokerList();
            }
            setData && setData(response.data);
            refetch();
          } else {
            notification.error({
              message: response.message,
            });
          }
        });
      } else {
        updateBroker({
          mgid: Number(mgid),
          brokerRequest: brokerRequest,
          associd: Number(associdState),
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            refetch();
            refetchBrokerList && refetchBrokerList();
          } else {
            notification.error({
              message: response.message,
            });
          }
        });
      }
    // }
    // if (brokerMgid && refetchBrokerList && close) {
    //   refetchBrokerList();
    //   close();
    // }
  };

  useEffect(() => {
    refetch();

    if (brokerDetail) {
      form.setFieldsValue({
        ...brokerDetail,
        enddate: brokerDetail.enddate ? moment(brokerDetail.enddate) : null,
        startdate: brokerDetail.startdate && moment(brokerDetail.startdate),
        brokerstatus: brokerDetail.brokerstatus,
        tprole: brokerDetail.tprole,
        broker: {
          tpname: brokerDetail.brokername,
          tpreference: brokerDetail.brokerreference,
          tpid: brokerDetail.tpidbroker,
        },
        mgid:mgid
      });
    } else {
      form.setFieldsValue({ startdate: moment(), brokerstatus: 'INIT' });
    }
  }, [form, brokerDetail, refetch,mgid]);

  return (
    <DF.Provider pagcode="brokerdetail">
      <Spin spinning={false}>
        <Form
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={submit}
          labelAlign="left"
          initialValues={{ mgid: mgid }}
        >
          <div className="card-container">
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                !isMyprofile && (
                  <Row>
                    <Form.Item
                      noStyle
                      shouldUpdate={shouldUpdateCompare('brokerstatus')}
                    >
                      {({ getFieldValue }) => (
                        <EnableDisableBrokerButton
                          mgid={Number(mgid)}
                          associd={Number(associdState)}
                          statusToUpdate={getFieldValue('brokerstatus')}
                          refetch={refetch}
                          disabled={isNil(associdState)}
                        />
                      )}
                    </Form.Item>
                    <SaveButton
                      comcode={isNil(associdState) ? 'save' : 'update'}
                    />
                  </Row>
                )
              }
            >
              <TabPane
                tab={
                  <>
                    <ArrowLeftOutlined
                      onClick={() => {
                        history.push(
                          `/configuration/management-company/brokers`
                        );
                      }}
                      hidden={associdbroker ? true : undefined}
                    />
                    <GetLabel label="BrokerDetail" />
                  </>
                }
                style={{
                  borderColor: 'transparent',
                }}
              >
                <Card>
                  <Row gutter={20} style={{ padding: 8 }}>
                    {isCreate && !showAsModal ? (
                      <FormInput
                        rules={[{ required: true }]}
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="broker"
                      >
                        <ThirdPartyInput role="BROKER" />
                      </FormInput>
                    ) : (
                      <FormInput
                        rules={[{ required: true }]}
                        col
                        xs={24}
                        lg={12}
                        xl={8}
                        name="broker"
                      >
                        <ModalControllerNV
                          modal={({ setVisible, visible }) => (
                            <ThirdPartyModal
                              tpId={brokerDetail?.tpidbroker}
                              visible={visible}
                              onCancel={() => setVisible(false)}
                              onSuccess={() => setVisible(false)}
                              title={brokerDetail?.brokername ?? ''}
                              iscreate={false}
                            />
                          )}
                          content={({ setVisible, visible }) => (
                            <a
                              onClick={() => {
                                setVisible(true);
                              }}
                            >
                              {brokerDetail?.brokername}
                            </a>
                          )}
                        />
                      </FormInput>
                    )}
                    <FormInput
                      col
                      xs={24}
                      lg={12}
                      xl={modal?8:6}
                      name="mgid"
                      hidden={modal}
                      rules={[{ required: true }]}
                    >
                      <MgCompanyList disabled={modal}/>
                    </FormInput>
                    <FormInput
                      rules={[{ required: true }]}
                      col
                      xs={24}
                      lg={12}
                      xl={6}
                      name="tprole"
                    >
                      <ParListSelect parcode="BRROLE" disabled={isMyprofile} />
                    </FormInput>

                    <FormInput
                      rules={[{ required: true }]}
                      col
                      xs={24}
                      lg={12}
                      xl={6}
                      name="networkcode"
                    >
                      <ParListSelect parcode="NETWORK" disabled={isMyprofile} />
                    </FormInput>
                    {/* <Form.Item
                      noStyle
                      shouldUpdate={shouldUpdateCompare([
                        'associd',
                        'statuslabel',
                      ])}
                    >
                      {({ getFieldValue }) => (
                        <FormInput
                          hidden={associdbroker ? true : undefined}
                          col
                          labelCol={{ span: 16 }}
                          xs={8}
                          lg={6}
                          xl={6}
                          name="statuslabel"
                        >
                          <Tag
                            color={
                              getFieldValue('brokerstatus') === 'ACTIVE'
                                ? 'success'
                                : getFieldValue('brokerstatus') === 'DISABLED'
                                ? 'error'
                                : 'default'
                            }
                          >
                            <Value value={getFieldValue('statuslabel')} />
                          </Tag>
                        </FormInput>
                      )}
                    </Form.Item> */}
                    <FormInput col xs={24} lg={12} xl={8} name="brokerstatus">
                      <Form.Item
                        noStyle
                        shouldUpdate={shouldUpdateCompare('brokerstatus')}
                      >
                        {({ getFieldValue }) => (
                          <Tag
                            color={
                              getFieldValue('brokerstatus') === 'ACTIVE'
                                ? 'success'
                                : getFieldValue('brokerstatus') === 'DISABLED'
                                ? 'error'
                                : 'default'
                            }
                          >
                            {getFieldValue('brokerstatus')}
                          </Tag>
                        )}
                      </Form.Item>
                    </FormInput>
                    <FormInput col xs={24} lg={12} xl={8} name="startdate">
                      <DatePicker
                        defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                        name="startdate"
                      />
                    </FormInput>

                    <FormInput col xs={24} lg={12} xl={8} name="enddate">
                      <DatePicker />
                    </FormInput>
                  </Row>

                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare('broker')}
                  >
                    {({ getFieldValue }) => (
                      <BrokerVendorsTab
                        mgid={Number(mgid)}
                        tpidbroker={
                          getFieldValue('tpidbroker') ||
                          getFieldValue('broker')?.tpid
                        }
                        associdState={isNil(associdState) ? true : false}
                      />
                    )}
                  </Form.Item>
                </Card>
              </TabPane>
              <TabPane
                tab={<GetLabel label="attribute" />}
                key="7"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <PricingAttirbuteTable
                  objectid={form.getFieldValue('broker')?.tpid ?? 0}
                  objecttype={form.getFieldValue('tprole') ?? 'BROKER'}
                  currcode={form.getFieldValue('currcode')}
                  brokerDetail={brokerDetail}
                />
              </TabPane>
              <TabPane
                tab={<GetLabel label="mguserauth" />}
                key="8"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <MgUserJobAuthorizationList
                  offerId={'' as any}
                  hideFiltersAndBtn
                  mgid={Number(mgid)}
                  tpid={form.getFieldValue('broker')?.tpid ?? 0}
                  tpname={form.getFieldValue('broker')?.tpname}
                  tpreference={form.getFieldValue('broker')?.tpreference}
                  tprole={form.getFieldValue('tprole') ?? 'BROKER'}
                  isTab
                  hidetpid
                  hidetprole
                />
              </TabPane>

              <TabPane
                tab={<GetLabel label="filering" />}
                key="9"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                {/* <BrokerFilteringTab mgid={0} tpidbroker={form.getFieldValue('broker')?.tpid ?? 0} /> */}
                <ParametersFilteringBroker
                  tpidbroker={form.getFieldValue('broker')?.tpid ?? 0}
                  isModal={modal}
                  mgid={Number(mgid)}
                  
                />
              </TabPane>

              <TabPane
                tab={<GetLabel label="offerfiltering" />}
                key="10"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <BrokerOfferTransfer
                  tpidbroker={form.getFieldValue('broker')?.tpid ?? 0}
                  mgid={Number(mgid)}
                />
              </TabPane>

              <TabPane
                tab={<GetLabel label="productfiltering" />}
                key="11"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <BokerProductTransfer
                  tpidbroker={form.getFieldValue('broker')?.tpid ?? 0}
                  mgid={Number(mgid)}
                />
              </TabPane>

              <TabPane
                tab={<GetLabel label="brokerThirdParty" />}
                key="12"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <BrokerThirdParty
                  tpidbroker={form.getFieldValue('broker')?.tpid ?? 0}
                  mgid={Number(mgid)}
                />
              </TabPane>
              <TabPane
                tab={<GetLabel label="services" />}
                key="13"
                destroyInactiveTabPane
                disabled={!form.getFieldValue('broker')?.tpid}
              >
                <ServiceListTable
                  hideAddButton
                  hideActionsButton 
                  tpid={form.getFieldValue('broker')?.tpid}            
                />
              </TabPane>
            </Tabs>
          </div>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

const useBrokerDetail = (
  mgid: number,
  associd: number,
  isMyprofile: boolean
) => {
  const MyBrokerProfile = useQuery(
    ['getMyBrokerProfile'],
    () =>
      getMyBrokerProfile({ mgid: Number(mgid), associd: 0 }).then(
        (res) => res.data
      ),
    {
      enabled: isMyprofile,
    }
  );

  const brokerDetail = useQuery(
    ['getBrokerByAssocID', { mgid, associd }],
    () =>
      getBrokerByAssocID({
        associd: associd,
        mgid: mgid,
      }).then((res) => res.data),
    {
      enabled: associd !== 0 && !isMyprofile,
    }
  );
  return isMyprofile ? MyBrokerProfile : brokerDetail;
};
export default BrokerDetail;
